import { cosemApi } from '@services/providers/cosem';
import { User, UserToCreate } from '@services/core/auth/auth.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

export const userApi = cosemApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.mutation<ApiPaginationResponse<User>, { limit?: number; page?: number; search?: string; orderBy?: string }>({
            query: ({ limit = 10, page = 1, search, orderBy }) => ({ url: '/core/users', method: 'GET',  params: { limit, page, search: search ?? "", orderBy: orderBy ?? "" } }),
            transformResponse: (response: ApiPaginationResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createUser: builder.mutation<ApiResponse<User>, UserToCreate>({
            query: (user: UserToCreate) => ({
                url: `/core/user`,
                method: 'POST',
                body: user
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateUser: builder.mutation<ApiResponse<User>, UserToCreate>({
            query: (user: UserToCreate) => ({ url: `/core/user/${user.id}`, method: 'PUT', body: user }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deleteUser: builder.mutation<ApiResponse<void>, { id: string }>({
            query: ({ id }) => ({ url: `/core/user/${id}`, method: 'DELETE' }),
            transformResponse: (response: ApiResponse<void>) => ({
                code: response.code,
                status: response.status,
                data: undefined
            })
        })
    })
});

export const { useGetUsersMutation, useCreateUserMutation, useUpdateUserMutation, useDeleteUserMutation } = userApi;
